import { graphql, fetchQuery } from 'react-relay';
import get from 'lodash.get';
import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { getItemIdFromUri } from '../../../utils/getItemIdFormUri';
import { PRIORITIES, SHOW_PDP_SOURCING } from '../pdpSharedNotificationConstants';

const query = graphql`
    query pdpSharedNotificationPdpSourcingModalConfigQuery(
        $itemId: String = ""
        $userId: String = ""
    ) {
        viewer {
            item(itemId: $itemId) {
                displayInfo(page: pdp, buyerId: $userId) {
                    ctas {
                        showRequestSourcing
                    }
                }
            }
        }
    }
`;

const pdpSourcingRule = ({ relayEnvironment }) => {
    const itemId = getItemIdFromUri(location.pathname);
    const userId = getBuyerId(document.cookie);
    const isTradeUser = getUserType(document.cookie) === 'trade';

    if (!itemId || !userId || !isTradeUser) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, query, { itemId, userId }).then(response =>
        get(response, 'viewer.item.displayInfo.ctas.showRequestSourcing')
    );
};

export const pdpSharedNotificationPdpSourcingModalConfig = {
    name: 'pdpSourcingModal',
    priority: PRIORITIES.PDP_SOURCING,
    rule: pdpSourcingRule,
    action: () => dispatch =>
        setTimeout(() => {
            dispatch({
                type: SHOW_PDP_SOURCING,
            });
        }, 5000),
};
